document.addEventListener('DOMContentLoaded', () => {
  var showSeeSimilarButton = false;
  const seeSimilarButton = document.querySelector('.see-similar-product');
  const bundleItems = document.querySelectorAll('.bundle-products-item');
  bundleItems.forEach(item => {
    sizesClickHandler(item.querySelectorAll('.size-fieldset-bundle .variant-item label'), item);
  });

  function sizesClickHandler(sizeItems, wrapper) {
    sizeItems.forEach(item => {
      item.addEventListener('click', () => {
        const oldSelectedSize = wrapper.querySelector('.variant-item label.is--selected');
        oldSelectedSize && oldSelectedSize.classList.remove('is--selected');
        item.classList.add('is--selected');
      })
    })
  }

  document.querySelectorAll('.variant-wrapper').forEach(wrapper => {
    let selectedColor = null;
    let selectedSize = null;
    let sizeValues = [];
    wrapper.querySelectorAll('.swatch-radio.size').forEach(x => {
      sizeValues.push(x.value);
    });
    updateColorLength(wrapper);
    const dropdown = wrapper.querySelector('select[data-variant-input]');
    if (!dropdown) return;

    const updateDropdown = () => {
      if (!selectedColor || !selectedSize) return;
      const combinedValue = `${selectedColor} / ${selectedSize}`;
      const optionToSelect = Array.from(dropdown.options).find(opt => opt.value === combinedValue);

      if (optionToSelect) {
        dropdown.value = combinedValue;
        dropdown.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    // Listen for color radio change
    wrapper.querySelectorAll('.swatch-radio.color').forEach(radio => {
      const allSizesByColor = showAvailableSizesByColor(dropdown, radio.value);
      var notavailableSizesByColor = getNotAvailableSizes(wrapper, radio.value, allSizesByColor);
      if (allSizesByColor.length == notavailableSizesByColor.length) // disable radio color button if all sizes are un available
      {
        radio.parentElement.classList.add('disabled');
      }
      radio.addEventListener('change', function (evt) {
        selectedColor = this.value;
        enableAllSizeOptions(wrapper);
        document.querySelector('.colorinfo' + evt.target.dataset.pid).textContent = selectedColor;
        const sizeRange = showAvailableSizesByColor(dropdown, selectedColor);

        wrapper.querySelector('.size-span').classList.remove('hide');
        if (sizeRange.length == 1) {
          wrapper.querySelector('.size-span').classList.add('hide');
        }
        wrapper.querySelector('.size-first-variant').innerText = sizeRange[0];
        wrapper.querySelector('.size-last-variant').innerText = sizeRange.length > 1 ? " - " + sizeRange[sizeRange.length - 1] : "";
        const notApplicableSized = [...sizeValues.filter(item => !sizeRange.includes(item)), ...sizeRange.filter(item => !sizeValues.includes(item))
        ];
        if (notApplicableSized.length > 0) {
          HideSizes(wrapper, selectedColor, notApplicableSized);
        }
        disableUnavailableSizeOptions(wrapper, selectedColor, sizeValues); // check unavailable combo in data tag and disabled them

        var disabledSizesCount = [...wrapper.querySelectorAll('.swatch-radio.size')].filter(el =>
          el.parentElement.classList.contains('disabled')
        )?.length;
        if (sizeRange.every(item=>notApplicableSized.includes(item)))  //check if all size options are disabled then add cross to color radio.
        {
          this.parentElement.classList.add('disabled');
          document.querySelector('.sizeinfo' + this.dataset.pid)?.classList.add('crossThrough'); // cross the size on label
        }
        else {
          seeSimilarProduct = false;
          this.parentElement.classList?.remove('disabled'); // remove cross from color radio button
          document.querySelector('.sizeinfo' + this.dataset.pid)?.classList.remove('crossThrough'); // remove cross from size  label
        }
        var isCurrentSelectedSizeInValid = wrapper.querySelector(`.swatch-radio.size[value="${selectedSize}"]`)?.parentElement.classList.contains('disabled');
        var sizeToSelect = isCurrentSelectedSizeInValid ? getFirstVisibleSizeValue(wrapper) : selectedSize;
        wrapper.querySelector(`.swatch-radio.size[value="${sizeToSelect}"]`)?.click();
        updateDropdown();
        var cloneNode = this.nextElementSibling.cloneNode(true);
        wrapper.querySelector('div.active-variant-image-' + evt.target.dataset.pid).innerHTML = '';
        wrapper.querySelector('div.active-variant-image-' + evt.target.dataset.pid).appendChild(cloneNode);
        handleAddtoCartButton();

        setAvailableSizeHandler(wrapper);

      });
      const allDisabled = Array.from(wrapper.querySelectorAll('.swatch-radio.color'))
        .every(el => el.parentElement.classList.contains('disabled'));
      if (allDisabled) {
        const noColorsAvailable = wrapper.querySelector('.no_colors_available');
        const colorLength = wrapper.querySelector('.color-length');
        const colorsAvailable = wrapper.querySelector('.colors_available');
        const variantLabelInfo = wrapper.querySelector('.variant__label-info');
        const activeVariantWrapper = wrapper.querySelector('.active-variant-wrapper');

        if (noColorsAvailable) {
          noColorsAvailable.style.display = 'inline-block';
        }
        if (colorLength) {
          colorLength.style.display = 'none';
        }
        if (colorsAvailable) {
          colorsAvailable.style.display = 'none';
        }
        if (variantLabelInfo) {
          variantLabelInfo.classList.add('crossThrough');
        }
        if (activeVariantWrapper) {
          activeVariantWrapper.firstElementChild.classList.add('disabled', 'crossThrough');
        }
      }
    });

    // Listen for size radio change
    wrapper.querySelectorAll('.swatch-radio.size').forEach(radio => {
      radio.addEventListener('change', function (evt) {
        selectedSize = this.value;
        var clickedOnDisabledSize = false;
        let selectedColorRadio = wrapper.querySelector(`.swatch-radio.color[value="${selectedColor}"]`);
        if (this.parentElement.classList.contains('disabled')) {
          selectedColorRadio.parentElement.classList.add('disabled');
          clickedOnDisabledSize = true;
        } else {
          selectedColorRadio.parentElement.classList.remove('disabled');
        }
        var element = document.querySelector('.sizeinfo' + evt.target.dataset.pid);
        element?.classList.remove('crossThrough');
        if (this.parentElement.classList.contains('disabled')) {
          element?.classList.add('crossThrough');
        }

        element.textContent = selectedSize;
        updateDropdown();
        handleAddtoCartButton();
      });
    });

    // Default selection based on dropdown value
    const lastSlashIndex = dropdown.value.lastIndexOf("/");
    const defaultPair = dropdown.value.split('/');
    const color = dropdown.value.substring(0, lastSlashIndex).trim();
    const size = dropdown.value.substring(lastSlashIndex + 1).trim(); // Dynamically using separator length

    wrapper.querySelector(`.swatch-radio.color[value="${color}"]`).click();
    wrapper.querySelector(`.swatch-radio.size[value="${size}"]`).click();
  });

  showSeeSimilarButton = isAnySwatchGroupCompletelyDisabled();
  if (showSeeSimilarButton) {
    const addToCartButton = document.querySelector('#addtobag');
    var anchorElement = document.querySelector('.product-form-default a.see-similar-product');
    var similarProductText = document.querySelectorAll('.see-similar-product-text');
    var sizeInputs = document.querySelectorAll('fieldset.size-fieldset .variant-input');
    var colorInputs = document.querySelectorAll('fieldset.is-color .variant-input');
    let dataCollectionValue = anchorElement?.getAttribute('data-collection-name');
    let dataCollectionSlug = anchorElement?.getAttribute('data-collection-slug');
    let inStockAvailablity = anchorElement?.getAttribute('data-inAvalibilty-slug');
    let inGender = anchorElement?.getAttribute('data-gender-slug');
    anchorElement?.classList.remove('hide-see-similar-cta');
    if (anchorElement && !anchorElement.classList.contains('hide-see-similar-cta') && addToCartButton) {
      addToCartButton.style.display = 'none';
    }
    similarProductText.forEach(function (allSimilarCTA) {
      allSimilarCTA.classList.remove('hide-similar-product-text');
    });
    var checkedInput = document.querySelector('input.variant-input-size-swatch:checked');
    var checkedValue = 'checkedInput ? checkedInput.value : undefined';
    if (checkedValue !== undefined) {
      var url = window.location.href.split('?')[0].split('/');
      var sizeQuery;
      if (url[url.length - 4] === 'collections') {
        sizeQuery =
          window.location.origin +
          '/' +
          url[url.length - 4] +
          '/' +
          url[url.length - 3] +
          dataCollectionSlug +
          checkedValue +
          inStockAvailablity + inGender;
      } else {
        sizeQuery =
          window.location.origin +
          '/collections/' +
          dataCollectionValue
      }
      if (anchorElement) {
        anchorElement.href = sizeQuery;
      }
    }
  }
  const colorSwatches = document.querySelectorAll('.variantlistcolor .variant-input label');
  const selectedColors = document.querySelectorAll('.variantlistcolor .variant-input input:checked');
  const sizeSwatches = document.querySelectorAll('.variantlistsize .variant-input label');
  // const swatchGroups = document.querySelectorAll('.variants-list.is--color');

  function changeImageHandler(position, value) {
    const productItem = document.querySelector(`.bundle_product__item[data-position="${position}"]`);
    const productImageElement = productItem.querySelector('.bundle_product__image img');
    if (productItem) {
      const images = productItem.dataset.images.split(',');
      const valueLower = value.toLowerCase();
      const valueLowerModified = value.toLowerCase().replaceAll('-', '').replaceAll(' ', '');
      let bundleItemImage = null;
      let matchCount = 0;

      for (const image of images) {
        const imageUrl = image.toLowerCase();
        const imageUrlModified = image.toLowerCase().replaceAll('-', '');

        if (imageUrl.includes(valueLower) || imageUrlModified.includes(valueLowerModified)) {
          matchCount++;
          bundleItemImage = image;
          if (matchCount === 2) break; // Stop when the second match is found
        }
      }

      const imageToSet = bundleItemImage || images[0];
      productImageElement.setAttribute('src', imageToSet);
    }
  }

  function setAvailableSizeHandler(wrapper) {
    let isCheckedSize = false;
    const variantListSizeAvailable = [...wrapper.querySelectorAll('.variantlistsize .variant-item')]
      .filter(el => {
        const label = el.querySelector('label');
        return label && !label.classList.contains('hide');
      });

    variantListSizeAvailable.forEach(sizeItem => {
      const input = sizeItem.querySelector('input');
      if (input.checked) {
        isCheckedSize = true;
      }
    })

    if (!isCheckedSize && variantListSizeAvailable.length > 0) {
      variantListSizeAvailable[0].querySelector('label').click();
    }
  }

  colorSwatches.forEach(colorItem => {
    colorItem.addEventListener('click', () => {
      const value = colorItem.querySelector('input').dataset.color.toLocaleLowerCase();
      changeImageHandler(colorItem.dataset.position, value);
    });
  });

  seeSimilarButton?.addEventListener('click', function (e) {
    e.preventDefault();
    window.location.href = this.dataset.bundleCollection;
  });

  selectedColors.forEach(colorItem => {
    const value = colorItem.dataset.color.toLocaleLowerCase();
    changeImageHandler(colorItem.parentNode.dataset.position, value);
  });

  function showAvailableSizesByColor(dropdown, color) {
    const options = Array.from(dropdown.options);

    const matchingSizes = options
        .filter(option => option.value.toLowerCase().startsWith(color.toLowerCase()))
        .map(option => {
            const lastSlashIndex = option.value.lastIndexOf('/');
            if (lastSlashIndex !== -1) {
                return option.value.substring(lastSlashIndex + 1).trim();
            }
            return ''; // Return empty string if no slash exists
        });

    const uniqueSizes = [...new Set(matchingSizes.filter(size => size))]; // Remove empty values

    return uniqueSizes; // Returns an array like ['S', 'M', 'L']
}
  function disableSizeOption(element) {
    if (element) {
      // element.disabled = true; // Disable the radio button

      // Find the parent label element
      let parentLabel = element.closest('label');

      if (parentLabel) {
        parentLabel.classList.add('disabled'); // Add the 'disabled' class to the label
      } else {
        console.warn("Parent label not found for the disabled radio button.");
      }
    } else {
      console.warn("Element not found in disableSizeOption function.");
    }
  }

  function enableAllSizeOptions(wrapper) {
    wrapper.querySelectorAll('.swatch-radio.size').forEach(element => {
      element.disabled = false; // Enable the radio button

      // Find the parent label element
      let parentLabel = element.closest('label');

      if (parentLabel) {
        parentLabel.classList.remove('disabled');
        parentLabel.classList.remove('hide');  // Remove the 'disabled' class from the label
      } else {
        console.warn("Parent label not found for the enabled radio button.");
      }
    });
  }

  function disableUnavailableSizeOptions(wrapper, selectedColor, sizeValues) {
    let notAvailable = wrapper.querySelector('div[data-not-available]').dataset.notAvailable?.split('-,');
    for (let i = 0; i < sizeValues.length; i++) {
      const key = selectedColor + '-' + sizeValues[i];
      if (notAvailable.indexOf(key) > -1) {
        let element = wrapper.querySelector(`.swatch-radio.size[value="${sizeValues[i]}"]`);
        disableSizeOption(element);
      }
    }
  }
  function getNotAvailableSizes(wrapper, selectedColor, sizeValues) {
    let notAvailable = wrapper.querySelector('div[data-not-available]').dataset.notAvailable?.split('-,');
    var notAvailableSizes = [];
    for (let i = 0; i < sizeValues.length; i++) {
      const key = selectedColor + '-' + sizeValues[i];
      if (notAvailable.indexOf(key) > -1) {
        notAvailableSizes.push(sizeValues[i]);
      }
    }
    return notAvailableSizes;
  }
  function HideSizes(wrapper, color, sizesTohide) {
    for (let i = 0; i < sizesTohide.length; i++) {
      let element = wrapper.querySelector(`.swatch-radio.size[value="${sizesTohide[i]}"]`);
      if (element) {
        element.parentElement.classList.add('hide');
      }
    }
  }
  function getFirstVisibleSizeValue(wrapper) {
    selector = '.swatch-radio.size';
    const elements = [...wrapper.querySelectorAll(selector)];
    const firstValue = elements
      .filter(el => {
        const parent = el.parentElement;
        return parent && !parent.classList.contains('hide') && !parent.classList.contains('disabled');
      })
      .map(el => el.value) // Adjust as needed: `.textContent`, `.getAttribute('value')`, etc.
    [0];
    return firstValue;
  }
  function handleAddtoCartButton() {
    const secondAddToCartbutton = document.querySelector('div.btn.btn--full.add-to-cart-event');
    const firstAddtocartButton = document.querySelector('button#addtobag');
    const priceBlock = document.querySelector('.fixed-price-block');
    const oosMessage = document.querySelector('.oos_message');
    // Show code to enable
    if (priceBlock) {
      priceBlock.style.display = '';
    }
    if (oosMessage) {
      oosMessage.style.display = 'none';
    }
    if (secondAddToCartbutton) {
      secondAddToCartbutton.classList.remove('disabled');
    }
    // Add code to disable
    if (firstAddtocartButton.attributes.disabled != undefined) {
      if(priceBlock)
      {
        priceBlock.style.display = 'none';
      }
      if(oosMessage){
        oosMessage.style.display = 'block';
      }
      if (secondAddToCartbutton) {
        secondAddToCartbutton.classList.add('disabled');
      }
    }

    if (!bundleAvailable) {
      document.body.classList.add('is--bundle-sold-out');
      seeSimilarButton.classList.remove('hide-see-similar-cta');
      seeSimilarButton.classList.add('is--bundle-similar');
    } else {
      document.body.classList.remove('is--bundle-sold-out');
      seeSimilarButton.classList.add('hide-see-similar-cta');
    }
  }

  function isAnySwatchGroupCompletelyDisabled() {
    const inputs = document.querySelectorAll('input[data-pid].variant__input--color-swatch');
    const pidGroups = {};
    // Group inputs by data-pid
    inputs.forEach(input => {
      const pid = input.dataset.pid;
      if (!pidGroups[pid]) pidGroups[pid] = [];
      pidGroups[pid].push(input);
    });
    // Return true if at least one group has all inputs disabled
    return Object.values(pidGroups).some(group =>
      group.every(input => {
        const label = input.closest('label');
        return label && label.classList.contains('disabled');
      })
    );
  }
  function updateColorLength(wrapper) {
    const colorInput = wrapper.querySelector('.variant-item .variant-input');
    const colorLengthSelector = wrapper.querySelector('.color-length');
    if (!colorInput || !colorLengthSelector) return;
    const bundleColorLength = colorInput.getAttribute('data-color-length');
    const finalColorLength = parseInt(bundleColorLength) - 1;
    colorLengthSelector.innerText = finalColorLength;
  }
});
